<template>
	<div class="pb-21" v-if="page">
		<div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-6 md:col-start-4 mt-21 max-md:pt-2 md:mt-24">
    			<p class="text-mini uppercase mb-4">{{$dateFormat(page.postDate)}} af {{page.authorName}}</p>
                <h1 class="headline mb-8">{{page.title}}</h1>

                <div class="text-big mb-8" v-html="page.excerpt"></div>

                <div class="content" v-html="page.postContent"></div>
            </div>
        </div>

        <template v-for="(entry, index) in page.sections" :key="index">
            <component :is="entry.__typename.replace('_Entry', '')" :data="entry"/>
        </template>
	</div>
</template>

<script setup>
const { $dateFormat } = useNuxtApp()
import { postQuery } from '@/api/queries'
import { onMounted } from 'vue';
const config = useRuntimeConfig();
const route = useRoute();

const page = ref(null)

// Build the URL, with `query` and `token` params:
const query = postQuery(route.params.slug[0])
const token = route.query.token;
const getData = async () => {
    const { data: gql } = await useFetch(config.public.API, {
        params: { query, token },
    });

    // Extract the first page from the response:
    if (gql.value) {
        page.value = gql.value.data.newsEntries[0];

        console.log('NEWS ITEM; ', page.value)
    }
}

await getData()

onMounted(() => {
    if (!page.value) {
        getData();
    }
})

useHead({
	title: `Sydhavn Teater — ${page?.value?.title}`,
	meta: [
		{ hid: 'og:title', property: 'og:title', content: `Sydhavn Teater — ${page?.value?.title}` },
		{ hid: 'og:image', property: 'og:image', content: page?.value?.media[0]?.url },
	],
});
</script>

<style lang="scss" scoped>
.content :deep(h2) {
    @apply text-mini mb-4 uppercase;
}

.content :deep(p) {
    @apply text-base-serif font-serif mb-4;
}
</style>